module.exports = __webpack_public_path__ + "static/media/file.ec9f33c8.png";